import React from "react";
import { Modal } from "antd";

const ConfirmationModal = ({ visible, onConfirm, onCancel, title, content }) => {
  return (
    <Modal
      title={title}
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Yes, Delete"
      cancelText="No, Cancel"
      okButtonProps={{ danger: true }}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ConfirmationModal;
